import { Injectable } from '@angular/core';
import { ApiType } from '../enumerators/enumerators.enum';
import { environment } from '../../environments/environment';
import { Config } from '../models/config.model';


@Injectable()
export class ConfigService {

    public config: Config;

    constructor() {
        this.config =
        {
            servicesUrl: this.getURLBase(),
            // extingueServicesUrl: 'aHR0cHM6Ly9leHRpbmd1ZXNlcnZpY2VzLWNzYnRlNWR0Y3hhMGF2ZmEud2VzdHVzLTAxLmF6dXJld2Vic2l0ZXMubmV0L2FwaS92MS8=', //Prod
            // extingueServicesUrl: 'aHR0cHM6Ly9sb2NhbGhvc3Q6NTAwNy9hcGkvdjEv', //local
            // extingueServicesUrl: 'aHR0cHM6Ly8xOTIuMTY4LjUuMTI5OjUwMDcvYXBpL3YxLw==', //Mobil
            extingueServicesUrl: this.getURLRest(),
            secret: 'SDBtMzFuNzNyMW9SMi5zMHMxLjFuQzNQdDFvLkg0c1ByMzJ1UHUzc1QwMg==',
            version: "1.5.1"
        };
    }

    getURLBase() {
        return environment.apiURL;
    }

    getURLRest(){
        return environment.extingueURL;
    }

    setURLBase(api: ApiType) {
        switch (api) {
            case ApiType.Security:
                this.config.servicesUrl = this.getURLBase();
                break;
            case ApiType.Rest:
                this.config.servicesUrl = localStorage.getItem('AOT')!;//local
                // this.config.servicesUrl = 'aHR0cHM6Ly8xOTIuMTY4LjUuMTI5OjUwMDYvYXBpL3YxLw==';//mobil
                break;
            // case ApiType.Sales:
            //     this.config.salesServicesUrl = localStorage.getItem('SOAT')!;
            //     break;
            default:
                break;
        }
    }
}
